type GiveButtonProps = {
  buttonColor?: string;
  buttonText: string;
  disabled?: boolean;
  onClick: () => void;
};

export function GiveButton({ onClick, buttonText, buttonColor, disabled }: GiveButtonProps) {
  return (
    <>
      <div>
        <button
          className={`min-w-full plb-2 items-center justify-center rounded-4 ${buttonColor}`}
          disabled={disabled}
          onClick={onClick}
        >
          {buttonText}
        </button>
      </div>
    </>
  );
}
